import { render } from "./FooterComponent.vue?vue&type=template&id=3ce115cf"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/hanlin-lesson-plan/hanlin-lesson-plan/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__